<template>
  <div>
    <Header>Late Route Form</Header>
    <div class="tiled-bar-image"></div>
    <Main>
      <div class="flex justify-center gap-2">
        <Button
          color="gray"
          size="md"
          @click="toVendorForms()">
          Back to Vendor Forms
        </Button>
      </div>
      <div class="mx-auto my-4">
        <!--Button color="gray" size="sm" @click="logFormValues()">Log Form Values</Button--> <!-- USED FOR TESTING ONLY -->
        <ValidationObserver v-slot="{ invalid, validate, errors, reset }">
          <form name="lateRouteForm" @submit.prevent="validate().then(() => onSubmit(invalid, reset))">
            <div class="container mb-3">
              <SelectRequiredData
                v-model="formValues.requiredData"
                :schoolYearOptions="schoolYearOptions"
                :vendorOptions="vendorOptions"
                :includeVendorSelect="includeVendorSelect"
                :includeSchoolYearSelect="false"
                :enableSchoolYearSelect="enableSchoolYearSelect">
              </SelectRequiredData>
            </div>
            <div class="container mb-3">
              <ValidationProvider rules="required" name="vehicle number" v-slot="{ errors }">
                <label class="text-left block">Vehicle Number</label>
                <v-select
                  class="w-1/3 pe-5 border-gray-300"
                  :options="vehicleList"
                  label="code"
                  v-model="formValues.vehicle"
                  return-object
                  @input="updateAvailableBuildings()"
                  placeholder="Please select the vehicle number"
                />
                <span
                  class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
                  name="error-text">
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
            </div>
            <div class="container mb-3">
              <ValidationProvider rules="required" name="school name" v-slot="{ errors }">
                <label class="text-left block">School or Program Name</label>
                <v-select
                  class="w-1/3 pe-5 border-gray-300"
                  :options="buildingList"
                  label="name"
                  v-model="formValues.building"
                  return-object
                  placeholder="Please select a school or program"
                />
                <span
                  class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
                  name="error-text">
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
            </div>
            <div class="container mb-3">
              <ValidationProvider :rules="`required`" name="late minutes" v-slot="{ errors }">
                <label class="text-left block">How many minutes late is the route running?</label>
                <v-select
                  class="w-1/3 pe-5 border-gray-300"
                  :options="minutesList"
                  label="displayText"
                  v-model="formValues.lateMins"
                  placeholder="Please select late minutes">
                </v-select>
                <!--TextField  
                  class="pe-5"
                  v-model="formValues.lateMins"
                  :type="'number'"
                  :min="'0'"
                >
                  How many minutes late is the route running?
                </TextField-->
                <span
                  class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
                  name="error-text">
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
            </div>
            <div class="container mb-3">
              <div class="text-sm font-bold flex flex-col gap-1">
                <ValidationProvider rules="required" name="boarding status" v-slot="{ errors }">
                  <RadioField
                    :options="boardingStatuses"
                    v-model="formValues.boardingStatus"
                    :alignment="'col'"
                  >
                    Boarding Status
                  </RadioField>
                  <span
                    class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
                    name="error-text">
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>
              </div>
            </div>
            <div class="container mb-3">
              <div class="text-sm font-bold flex flex-col gap-1">
                <ValidationProvider rules="required" name="late reason" v-slot="{ errors }">
                  <RadioField
                    :options="lateReasons"
                    v-model="formValues.lateReason"
                    :alignment="'col'"
                  >
                    Reason route is running late
                  </RadioField>
                  <span
                    class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
                    name="error-text">
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>
              </div>
            </div>
            <div class="container mb-3">
              <TextArea 
                class="w-1/2"
                v-model="formValues.additionalInfo"
              >
                Additional Info
              </TextArea>
            </div>
            <div class="container mt-3">
              <div class="w-full rounded-md bg-gray-200 p-2 my-2"
                v-if="!canSubmit">
                <span class="uppercase text-gray-500">
                  Missing Permissions to Submit Form
                </span>
              </div>
              <div class="flex flex-row">
                <span class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
                  name="error-text"
                  v-if="displayFormHasErrors(errors)">
                  There are errors in fields above.
                </span>
              </div>
              <SubmitButton
               class="rounded-md font-medium text-white bg-sky-600 px-3 py-2 hover:bg-blue-200 transition-colors shadow-sm"
                type="submit"
                color="blue"
                size="md"
                :disabled="!canSubmit"
                :submitting="submitting">
                Submit Form
              </SubmitButton>
            </div>
          </form>
        </ValidationObserver>
      </div>
      <!-- <p>Endpoint Data: {{ formValues }}</p> -->
    </Main>
  </div>
</template>

<style scoped>
.tiled-bar-image {
  width: 100%;
  height: 25px;
  background-image: url("@/assets/Bar.png");
  background-repeat: repeat-x;
}
</style>

<script>
import Main from '../components/Main.vue'
import Header from '../components/Header.vue'
import Button from '../components/Button.vue'
import SubmitButton from '../components/SubmitButton.vue'
import RadioField from '../components/formComponents/RadioField.vue'
//import TextField from '../components/formComponents/TextField.vue'
import TextArea from '../components/formComponents/TextArea.vue'
import SelectRequiredData from '../components/SelectRequiredData.vue'

// import districts from '../services/districts.js'

import DROPDOWN_LISTS from '../components/DropdownLists.json'

import { getLateRoutesSheetData } from '../services/api.js'
import lateRouteFormService from '../services/pages/lateRouteForm.js'
import user from '../services/user/user.js'
  
export default {
  components: {
    Main,
    Header,
    Button,
    SubmitButton,
    RadioField,
    //TextField,
    TextArea,
    SelectRequiredData,
  },
  data() {
    return {
      user: undefined,
      formValues: {
        requiredData: {},
      },

      vendorOptions: [],
      schoolYearOptions: [],
      includeVendorSelect: false,
      enableSchoolYearSelect: true,

      vendorId: undefined,
      today: '',

      boardingStatuses: [],
      buildingList: [],
      lateReasons: [],
      minutesList: [
        { value: 10, displayText: "10 minutes" }, 
        { value: 15, displayText: "15 minutes" }, 
        { value: 20, displayText: "20 minutes" }, 
        { value: 25, displayText: "25 minutes" }, 
        { value: 30, displayText: "30 minutes" }, 
        { value: 35, displayText: "35 minutes" }, 
        { value: 40, displayText: "40 minutes" }, 
        { value: 45, displayText: "45 minutes" }, 
        { value: 50, displayText: "50 minutes" }, 
        { value: 55, displayText: "55 minutes" }, 
        { value: 60, displayText: "1 hour" }, 
        { value: 65, displayText: "1 hour, 5 minutes" }, 
        { value: 70, displayText: "1 hour, 10 minutes" }, 
        { value: 75, displayText: "1 hour, 15 minutes" }, 
        { value: 80, displayText: "1 hour, 20 minutes" }, 
        { value: 85, displayText: "1 hour, 25 minutes" }, 
        { value: 90, displayText: "1 hour, 30 minutes" }, 
        { value: 95, displayText: "1 hour, 35 minutes" }, 
        { value: 100, displayText: "1 hour, 40 minutes" }, 
        { value: 105, displayText: "1 hour, 45 minutes" }, 
        { value: 110, displayText: "1 hour, 50 minutes" }, 
        { value: 115, displayText: "1 hour, 55 minutes" }, 
        { value: 120, displayText: "2 hours" }
      ],
      routeList: [],
      vehicleList: [],

      canSubmit: true,
      submitting: false,
    }
  },
  methods: {
    async onSubmit(formInvalid, reset) {
      let hasError = this.scrollToFirstError()

      if (formInvalid || hasError) {
        return false
      }

      this.submitting = true

      let partition
      let vendor = { name: 'Unselected' }
      if (this.formValues.requiredData.vendorId) {
        vendor = await lateRouteFormService.getVendor(this.formValues.requiredData.vendorId)
        partition = await lateRouteFormService.getPartition(vendor.partition)
      }
      else {
        partition = await lateRouteFormService.getDistrict(this.formValues.building.district)
      }

      console.log(vendor)

      let submissionPayload = {
        db_data: {
          school_year: this.formValues.requiredData?.schoolYearCode,
          vehicle: this.formValues.vehicle?.id,
          building: this.formValues.building?.id,
          late_mins: this.formValues.lateMins?.value,
          boarding_status: this.formValues.boardingStatus,
          late_reason: this.formValues.lateReason,
          additional_info: this.formValues.additionalInfo,
        },
        email_data: {
          //contractor: vendor?.name,
          current_date: new Date().toLocaleString().split(',')[0],
          nws_route_number: '',
          vehicle_number: this.formValues.vehicle?.code.trim(),
          school: this.formValues.building,
          minutes_late: this.formValues.lateMins?.value,
        }
      }

      let submissionDate = new Date();
      let formattedDate = new Intl.DateTimeFormat('en-US', { // date should always be submitted in Central Time, not local time
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        hour12: false,
        timeZone: 'America/Chicago',
      }).format(submissionDate);

      formattedDate = formattedDate.replace(',', '');

      let spreadsheetRow = [
        `Just Rec'd`, // Status
        formattedDate, // Time Stamp
        vendor?.name, // Contractor
        this.formValues.vehicle?.code, // Route Number
        `${this.formValues.building?.name} (for ${partition?.description})`, // School
        this.formValues.lateMins?.value, // How many minutes late is the route running
        DROPDOWN_LISTS.boardingStatuses[this.formValues.boardingStatus], // Boarding Status
        DROPDOWN_LISTS.lateReasons[this.formValues.lateReason], // Reason route is running late
        `${this.user?.getFirstName()} ${this.user?.getLastName()}`, // Person submitting late route
        this.formValues.additionalInfo, // Additional Info
        '', // Formula Copy Down Status
        '', // School Email
        '', // School Phone
        '', // Contractor Email
        '', // Contractor Phone
        this.jsDateToExcelDateValue(submissionDate), // Timestamp_As_Value
        this.formValues.vehicle?.code, // Whole Route Number as Text
        this.formValues.vehicle?.code?.match(/\d/g).join(''), // Route_Number
        `${this.formValues.building?.name} (FOR ${partition?.description})`.toUpperCase(), // School
        '', // Public_Reason
        '', // District
        '', // NWS Route No
        '' // SCHOOL Template - Send Status
      ];

      let sheetPromise = lateRouteFormService.putLateRoutesSheetData(spreadsheetRow)
      let lateFormPromise = lateRouteFormService.postNewLateRouteForm(submissionPayload)

      Promise.all([sheetPromise, lateFormPromise]).then(() => {
        this.submitting = false
        this.formValues = {
          requiredData: {},
        }
        this.validateProvidedInfo()
        reset() // prevents form errors from firing when formValues is blanked
      }).catch(() => {
        this.submitting = false
      })
    },
    scrollToFirstError() {
      const elems = document.getElementsByName('error-text');
      let hasError = false;
      
      for(let el of Array.from(elems)) {
        if(el.innerText && el.innerText.trim()) {
          hasError = true;
          el.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'center'
          });
          break;
        }
      }

      return hasError;
    },
    displayFormHasErrors(errorsMap) {
      return Object.values(errorsMap).flat().length > 0;
    },
    toVendorForms() {
      this.$router.push({
        name: 'VendorForms',
      });
    },
    async updateRequestFormOptions() {
      let schoolYearOptions = await lateRouteFormService.getNewRequestFormOptionsFromCapability(this.user)
      this.schoolYearOptions = schoolYearOptions
    },
    async updateAvailableBuildings() {
      this.buildingList = (await lateRouteFormService.getNewLateRouteSequenceFromServer({
        date: this.today,
        vehicleId: this.formValues.vehicle?.id,
      })).data
      this.formValues.building = undefined
    },
    async readFromSpreadsheet() {
      let spreadsheetValues = await getLateRoutesSheetData();
      console.log(`spreadsheetValues: `, spreadsheetValues);
    },
    jsDateToExcelDateValue(jsDate) {
      return (jsDate - new Date(1899,11,30)) / (1000 * 60 * 60 * 24).toFixed(10);
      //return 25569.0 + ((jsDate.getTime() - (jsDate.getTimezoneOffset() * 60 * 1000)) / (1000 * 60 * 60 * 24)); // for returning excel date in local time
    },
    /*async logFormValues() { // USED FOR TESTING ONLY
      console.log(`this.formValues: `, this.formValues);
    }*/

    async validateProvidedInfo() {
      this.schoolYearOptions = await lateRouteFormService.getLateRouteFormSchoolYearOptionsFromCapability(this.user)
      this.vendorOptions = await lateRouteFormService.getLateRouteFormVendorOptionsFromCapability(this.user)

      let userConfigVendorId = this.user.getConfig('vendor_id')

      if (userConfigVendorId) {
        this.includeVendorSelect = true
        this.$set(this.formValues.requiredData, 'vendorId', userConfigVendorId)
      }

      let capViewLateRouteForm = this.user.getCapability('view_late_route_form')
      let schoolYearOptions = capViewLateRouteForm.getSchoolYearOptions()
      if (schoolYearOptions.length > 1) {
        this.enableSchoolYearSelect = true
      }
      else if (schoolYearOptions.length === 1) {
        this.enableSchoolYearSelect = false
        this.$set(this.formValues.requiredData, 'schoolYearCode', schoolYearOptions[0].schoolYear)
      }

      this.canSubmit = lateRouteFormService.canSubmitForm(this.user)
    },
    checkUserCanViewPage() {
      if (!this.user.can('view_late_route_form')) {
        this.$router.push({
          name: 'VendorForms'
        })
        return true
      }
    },
  },
  async created() {
    this.user = await user.get()
    if (this.checkUserCanViewPage()) {
      return
    }

    this.validateProvidedInfo()

    let today = new Date()

    let month = today.getMonth() + Number(1)
    if (month < 10) month = '0' + month

    let date = today.getDate()
    if (date < 10) date = '0' + date

    this.today = today.getFullYear() + '-' + month + '-' + date

    this.vehicleList = (await lateRouteFormService.getNewLateRouteSequenceFromServer({ date: this.today })).data
  },
  mounted() {
    this.boardingStatuses = DROPDOWN_LISTS.boardingStatuses;
    this.lateReasons = DROPDOWN_LISTS.lateReasons;
  },
  watch: {
    'formValues.requiredData.vendorId': function () {
      lateRouteFormService.getNewLateRouteSequenceFromServer({ date: this.today })
        .then(result => {
          this.vehicleList = result.data
        })
    }
  },
}
</script>